/**
 * fontLicense/urlValidation.ts
 *
 * Pure helpers for validating and comparing Jira task URLs. Kept free of React
 * and network dependencies so they are trivially unit-testable.
 */

import { JIRA_TASK_URL_PATTERN, JIRA_TASK_URL_PREFIX } from './model';

/** Normalizes a Jira URL the same way the backend does: trim + strip trailing slashes. */
export function normalizeJiraUrl(url: string | null | undefined): string {
  return (url ?? '').trim().replace(/\/+$/, '');
}

/**
 * True when the (normalized) URL matches the required Jira task URL format.
 *
 * Format is the only rule: a legal task may cover several fonts, so the same URL
 * is allowed on any number of licenses (the backend dropped its uniqueness check
 * too).
 */
export function isValidJiraUrl(url: string | null | undefined): boolean {
  return JIRA_TASK_URL_PATTERN.test(normalizeJiraUrl(url));
}

/**
 * True when the field holds nothing but the prefilled prefix — the input is not
 * empty (so antd's `required` rule passes), yet the user has typed no task number.
 */
export function isJiraUrlPrefixOnly(url: string | null | undefined): boolean {
  return normalizeJiraUrl(url) === JIRA_TASK_URL_PREFIX;
}
